// app/javascript/controllers/scroll_to_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        target: String
    }

    scroll(event) {
        event.preventDefault()

        const selector = this.targetValue
        if (!selector) return

        const target = document.querySelector(selector)
        if (!target) return

        target.scrollIntoView({
            behavior: "smooth",
            block: "start"
        })
    }
}